import { Container, Tab, Tabs } from "react-bootstrap";
import CookiesPolicy from "../../components/tabs/global-settings/CookiesPolicy";
import GeneralSettings from "../../components/tabs/global-settings/GeneralSettings";
import PrivacyPolicy from "../../components/tabs/global-settings/PrivacyPolicy";
import TermsOFService from "../../components/tabs/global-settings/TermsOFService";

const GlobalSettings = () => {
  return (
    <Container className="w-800">
      {/* <PageHeader title="Settings" /> */}
      <div className="title-wrap">
        <div className="title-wrap--heading">
          <h1>Settings</h1>
        </div>
      </div>
      <div className="tabs-wrapper">
        <Tabs defaultActiveKey="terms" id="eds-admin-settings">
          {/* Terms of use tab  */}
          <Tab eventKey="terms" title="Terms of use">
            <TermsOFService />
          </Tab>

          {/* Privacy policy tab  */}
          <Tab eventKey="privacy-policy" title="Privacy policy">
            <PrivacyPolicy />
          </Tab>

          {/* Cookies policy tab  */}
          <Tab eventKey="cookies-policy" title="Cookies policy">
            <CookiesPolicy />
          </Tab>

          {/* General settings Tab */}
          <Tab eventKey="general-settings" title="General settings">
            <GeneralSettings />
          </Tab>
        </Tabs>
      </div>
    </Container>
  );
};

export default GlobalSettings;
